export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10912.97b8a575.jpg";